export default __webpack_public_path__ + "static/media/school-hat.387304bf.svg";